import { useAppDisplayModeContext } from '@archipro-design/aria';

import React from 'react';

import { TeamMembersDesktop } from './TeamMembers.desktop';
import { TeamMembersMobile } from './TeamMembers.mobile';

import type { TeamMemberView } from '@modules/professional/type/team-member';

export const TEAM_MEMBERS_PER_PAGE_DESKTOP = 10;
export const TEAM_MEMBERS_PER_PAGE_MOBILE = 4;
const MEMBER_PLACEHOLDER_IMAGE = `/assets/website/images/MemberPlaceholder.svg`;

export const getMemberPlaceholderImage = (assetsBaseUrl: string) =>
    `${assetsBaseUrl}${MEMBER_PLACEHOLDER_IMAGE}`;

export interface TeamMembersResult {
    teamMembers: TeamMemberView[];
    disablePhotoViewer?: boolean;
    pageInfo: {
        hasNextPage?: boolean | null;
        hasPreviousPage?: boolean | null;
        totalCount: number;
        currentPage?: number;
    };
}

export const TeamMembers: React.FC<
    TeamMembersResult & { sectionTitle: string }
> = (props) => {
    const { mobile } = useAppDisplayModeContext();

    if (mobile) {
        return <TeamMembersMobile {...props} />;
    }

    return <TeamMembersDesktop {...props} />;
};
